export const enum ShareType {
  CLIPBOARD = 'referral-code-link',
  EMAIL = 'email',
  FACEBOOK = 'facebook',
  X_TWITTER = 'twitter',
}
